import React from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { BeneficiaryForm } from '../Forms';
import { EditBeneficiaryForm } from "../Forms";
import { Text1, Text4 } from '../../../styles';

const BeneficiaryModal = (props) => {
    const renderTitle = () => {
        return (
            <div className="mb-4">
                <Text1 className="d-block" strong>
                    {`${props?.beneficiary?.is_edit ? "Update" : "Create"} Beneficiary`}
                </Text1>
                <Text4 className="d-block"><i>For {props.contact.name}</i></Text4>
            </div>
        )
    };
    
    return (
        <EaseModal
            width={350}
            title={false}
            visible={props.visible}
            onCancel={props.toggleBeneficiaryModal}
            centered
            hideHeader
            hideFooter
            destroyOnClose
        >
            <div>
                {renderTitle()}
                {props?.beneficiary?.is_edit ? 
                    <EditBeneficiaryForm
                        beneficiary={props.beneficiary}
                        contact={props.contact}
                        loading={props.loading}
                        onSubmit={props.onSubmit}
                    />
                :
                    <BeneficiaryForm
                        beneficiary={props.beneficiary}
                        contact={props.contact}
                        loading={props.loading}
                        onSubmit={props.onSubmit}
                    />
                }
            </div>
        </EaseModal>
    )
};

BeneficiaryModal.defaultProps = {
    // beneficiary: { beneficiary_type: "bank_account" }
}

export { BeneficiaryModal };